import { ECOMemberPassIntegrationGetters } from './partials/eco-member-pass'
import { ECOPortalIntegrationGetters } from './partials/eco-portal'
import { OWRIntegrationGetters } from './partials/owr'
import { TmetricGetters } from './partials/tmetric'

export const IntegrationGetters = {
  ...ECOMemberPassIntegrationGetters,
  ...ECOPortalIntegrationGetters,
  ...OWRIntegrationGetters,
  ...TmetricGetters,
}
